import stylesad2 from "../../pages/Admin/Admin2.module.css";
import DateService from "../../services/DateService";
import BtnSwitch from "../Button/BtnSwitch";
import {commentAdd, commentCheck, toggleComments} from "../../services/CommentService";
import stylesSwitch from "../Button/BtnSwitch.module.css";
import {Link} from "react-router-dom";
import Routing from "../../services/routing";
import React, {useState} from "react";
import {useModal} from "../../contexts/ModalContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";

function AddComment({ urlAddComment, urlGetComments, setComments }) {
    const [showAddForm, setShowAddForm] = useState(false);
    const [newComment, setNewComment] = useState({ title: '', text: '', dateNotif: '', check: '' });
    const [submitting, setSubmitting] = useState(false);
    const {showModal, hideModal} = useModal();

    const handleSuccess = (children = "Enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    return <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        {!showAddForm ? (
            <button
                className={"btn btn_main"}
                onClick={() => setShowAddForm(true)}>
                <FontAwesomeIcon icon={faPlus} /> Ajouter un commentaire
            </button>
        ) : (
            <div className={stylesad2.blok} style={{ width: "100%" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <p style={{ margin: 0, fontWeight: "600" }}>Nouveau commentaire</p>

                    <input
                        type="text"
                        placeholder="Titre *"
                        value={newComment.title}
                        onChange={(e) => setNewComment(prev => ({ ...prev, title: e.target.value }))}
                        style={{ padding: "6px 10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: ".9rem" }}
                    />

                    <textarea
                        placeholder="Texte (optionnel)"
                        value={newComment.text}
                        onChange={(e) => setNewComment(prev => ({ ...prev, text: e.target.value }))}
                        rows={3}
                        style={{ padding: "6px 10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: ".8rem", resize: "vertical" }}
                    />

                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                        <label style={{ fontSize: ".8rem", color: "#666" }}>Date de notification (optionnel)</label>

                        <input
                            type="datetime-local"
                            value={newComment.dateNotif}
                            onChange={(e) => setNewComment(prev => ({ ...prev, dateNotif: e.target.value }))}
                            style={{ padding: "6px 10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: ".9rem", width: "fit-content" }}
                        />
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", gap: "4px" }}>
                        <input
                            id={"check"}
                            type="checkbox"
                            value={newComment.check}
                            onChange={(e) => setNewComment(prev => ({ ...prev, check: e.target.value }))}
                            style={{ padding: "6px 10px", borderRadius: "6px", border: "1px solid #ccc", fontSize: ".9rem", width: "fit-content" }}
                        />
                        <label htmlFor={"check"} style={{ fontSize: ".8rem", color: "#666" }}>Afficher une case à cocher "À traiter"</label>
                    </div>

                    <div style={{ display: "flex", gap: "8px", marginTop: "4px" }}>
                        <button
                            className={"btn btn_success"}
                            onClick={async () => await commentAdd(
                                newComment,
                                handleError,
                                handleSuccess,
                                setSubmitting,
                                urlAddComment,
                                setNewComment,
                                setShowAddForm,
                                async () => await toggleComments(urlGetComments, setComments, handleError)
                            )}
                            disabled={submitting}
                            style={{ opacity: submitting ? 0.6 : 1 }}
                        >
                            {submitting ? "Envoi..." : <><FontAwesomeIcon icon={faPlus} /> Envoyer</>}
                        </button>
                        <button
                            className={"btn btn_danger"}
                            onClick={() => {
                                setShowAddForm(false);
                                setNewComment({ title: '', text: '', dateNotif: '', check: null });
                            }}
                            disabled={submitting}
                        >
                            Annuler
                        </button>
                    </div>
                </div>
            </div>
        )}
    </div>;
}

export default AddComment;